import { createContext, PropsWithChildren } from "react";
import { useAuth } from "../hooks/useAuth";

export const AuthContext = createContext<ReturnType<typeof useAuth>>({
  login: () => Promise.reject(),
  register: () => Promise.reject(),
  logout: () => void 0,
  resetPassword: () => Promise.reject(),
  resendConfirmEmail: () => Promise.reject(),
  user: null
});

export const AuthProvider = (props: PropsWithChildren) => (
  <AuthContext.Provider value={useAuth()} {...props} />
);
